/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerGoogleBigqueryDestinationComponent', [
    '$rootScope',
    'DesignerBaseDatabaseDestinationComponent',

    function ($rootScope, DesignerBaseDatabaseDestinationComponent) {
      function DesignerGoogleBigqueryDestinationComponent() {
        DesignerBaseDatabaseDestinationComponent.apply(this);

        this.max_bad_records = null;
      }

      DesignerGoogleBigqueryDestinationComponent.prototype = new DesignerBaseDatabaseDestinationComponent();

      DesignerGoogleBigqueryDestinationComponent.prototype.getData = function () {
        const data = DesignerBaseDatabaseDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          max_bad_records: this.max_bad_records || this.defaults.max_bad_records,
        });

        return data;
      };

      DesignerGoogleBigqueryDestinationComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerBaseDatabaseDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerGoogleBigqueryDestinationComponent.prototype.setData = function (data) {
        this.max_bad_records = data.max_bad_records;

        DesignerBaseDatabaseDestinationComponent.prototype.setData.call(this, data);
      };

      return DesignerGoogleBigqueryDestinationComponent;
    },
  ]);
})(window.angular);
